var _polygon, _rect, _rect2, _path, _rect3, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Finance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Finance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.32,171.64a57.64,57.64,0,1,0-20.42-28l-25.38,38Z",
    style: {
      fill: "#c6d0dc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.99 498.5 133.86 474.88 156.94 204.38 380.92 223.48 356.99 498.5",
    style: {
      fill: "#c6d0dc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.91,
    y: 189.75,
    width: 161,
    height: 271.48,
    transform: "translate(28.62 -21.38) rotate(4.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.93,
    y: 123.72,
    width: 238.6,
    height: 325.85,
    style: {
      fill: "#59aee4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.93,
    y: 155.89,
    width: 238.6,
    height: 232.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.23,
    cy: 417.72,
    r: 12.47,
    style: {
      fill: "#e83e38"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.17,
    y: 386.7,
    width: 18.35,
    height: 62.87,
    style: {
      fill: "#548fbf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.17,
    y: 124.26,
    width: 18.35,
    height: 31.44,
    style: {
      fill: "#548fbf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.96,
    y: 155.89,
    width: 18.35,
    height: 230.8,
    style: {
      fill: "#c6d0dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,148.89a57.65,57.65,0,1,0-20.41-28l-25.39,38Z",
    style: {
      fill: "#f7c648"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.2 238.08 218.14 250.08 229.97 250.13 202.02 278.07 190.94 266.99 157.57 300.35 147.06 289.84 112.19 324.71 120.67 333.19 147.06 306.81 157.57 317.32 190.94 283.96 202.02 295.04 237.96 259.11 237.91 269.76 249.91 269.82 250.06 238.23 218.2 238.08",
    style: {
      fill: "#ef835e"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "102.26 222.04 90.26 222.04 90.26 359.24 272.26 359.24 272.26 347.24 102.26 347.24 102.26 222.04"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 244.03,
    y: 175.15,
    width: 35.23,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 244.03,
    y: 192.58,
    width: 35.23,
    height: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.23,399.25a18.47,18.47,0,1,0,18.47,18.47A18.49,18.49,0,0,0,182.23,399.25Zm0,24.94a6.47,6.47,0,1,1,6.47-6.47A6.47,6.47,0,0,1,182.23,424.19Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 159.23,
    y: 133.7,
    width: 46,
    height: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.41,82.59a63.64,63.64,0,0,0-121.54,37.65l-32.05,47.94,57.74-12.53a63.64,63.64,0,0,0,95.85-73.06Zm-43.89,69.2a51.72,51.72,0,0,1-47.1-7.39l-2.18-1.61-33.94,7.36,18.77-28.07-.94-2.79a51.64,51.64,0,1,1,65.39,32.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.88,98.22,415.12,96q-7.17-1.77-7.17-6.19a5.65,5.65,0,0,1,2.28-4.61,10.18,10.18,0,0,1,6.24-1.8h.59q7.29.09,9.31,5.84l8.84-2.19a13.12,13.12,0,0,0-6.66-8.23,22.38,22.38,0,0,0-6.41-2.35V65.63h-12V76.78a17.88,17.88,0,0,0-6.61,3.34,13.54,13.54,0,0,0-5.14,11.08,15,15,0,0,0,1.46,6.53,11.61,11.61,0,0,0,3.87,4.74,24.25,24.25,0,0,0,7.47,3l9.86,2.57c2.64.68,4.37,1.62,5.17,2.82a6.78,6.78,0,0,1,1.21,3.9,5.89,5.89,0,0,1-2.66,4.88,12.07,12.07,0,0,1-6.89,1.94h-1.53q-10.08-.28-11.65-7.65l-9,1.93a15.76,15.76,0,0,0,7.65,10,24.63,24.63,0,0,0,6.82,2.52v11.67h12V128.62a21.07,21.07,0,0,0,9.43-3.91,14.21,14.21,0,0,0,5.72-11.95,14.83,14.83,0,0,0-2.72-8.63Q431.86,100.23,423.88,98.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.14,243.71l4.55-51.88-36.86-3.24-1.05,12,24.91,2.19-3.51,39.92a26.73,26.73,0,0,0-13.65,6.1A27,27,0,0,0,324,267.14l12,1.05a15,15,0,0,1,5.31-10.26,14.81,14.81,0,0,1,4.8-2.72l-2.59,29.47a27,27,0,0,0-23.16,24.47l11.95,1.05a15.06,15.06,0,0,1,10.11-13l-2.58,29.47a26.65,26.65,0,0,0-13.65,6.1,27,27,0,0,0-9.52,18.38l11.95,1.05A15.07,15.07,0,0,1,333.9,342a14.75,14.75,0,0,1,4.81-2.72l-2.59,29.47a26.65,26.65,0,0,0-13.65,6.1A27,27,0,0,0,313,393.18l11.95,1.05A15.11,15.11,0,0,1,330.21,384a14.93,14.93,0,0,1,4.81-2.71l-7,80-64.67-5.67h44.2V117.72H56.93V455.57h69.16L338.9,474.25l4.55-51.88a27.13,27.13,0,0,0,15-46.37,27.16,27.16,0,0,0,5.67-39.88,26.81,26.81,0,0,0-2-2.14,27.16,27.16,0,0,0,5.68-39.87,25.31,25.31,0,0,0-2-2.14,27.16,27.16,0,0,0,5.68-39.87A26.69,26.69,0,0,0,359.14,243.71Zm-290.21-114h226.6v20H68.93Zm0,32h226.6v219H68.93Zm0,281.87V392.7h226.6v50.87Zm285.75-46.73a15.13,15.13,0,0,1-10.12,13L347,382.3a15,15,0,0,1,7.71,14.54Zm3.68-42a15.09,15.09,0,0,1-10.12,13l2.42-27.52a15,15,0,0,1,7.7,14.54Zm3.69-42a15.11,15.11,0,0,1-10.12,13l2.42-27.53a14.93,14.93,0,0,1,4.26,3.52A15.08,15.08,0,0,1,362.05,312.82Zm3.69-42a15.11,15.11,0,0,1-10.12,13L358,256.26a14.89,14.89,0,0,1,4.26,3.51A15.1,15.1,0,0,1,365.74,270.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/구매팀.faf0ef83660b9bb3e847c8a47fa77e2f.svg";
export { ForwardRef as ReactComponent };